// @ts-ignore - React's types use `export =`, but runtime re-export works fine.
export * from "react";
// @ts-ignore - Same reason as above; default export remains React.
export { default } from "react";
